export const SnackbarConstants={
    Set_SNACKBAR : "SET_SNACKBAR"
}